import { render, staticRenderFns } from "./personalAssetsList.vue?vue&type=template&id=2de69596&scoped=true"
import script from "./personalAssetsList.vue?vue&type=script&lang=js"
export * from "./personalAssetsList.vue?vue&type=script&lang=js"
import style0 from "./personalAssetsList.vue?vue&type=style&index=0&id=2de69596&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de69596",
  null
  
)

export default component.exports